import { useCallback } from 'react';

import { useCurrentUserStore } from 'store/currentUser';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';
import type { ErrorMetricsParams } from 'YM/Rules/error';

import { provider } from 'providers';
import { EVoxRoles } from 'providers/declare';

import { useConferenceId } from 'hooks/useConferenceId';

import { getDevicesPermissionMap } from 'utils/getDevicesPermissionMap';

export function useSendErrorMetrics() {
    const { triggerYM } = useYM();
    const { currentUser } = useCurrentUserStore();
    const conferenceId = useConferenceId();

    return useCallback(
        <T>({ data, name }: { data: T; name: string }) => {
            (async () => {
                const { camera, microphone } = await getDevicesPermissionMap();

                triggerYM<ErrorMetricsParams>({
                    data: {
                        Meeting: {
                            Meeting_params: {
                                meeting_id: conferenceId,
                                meeting_role: currentUser?.role ?? EVoxRoles.GUEST,
                                setting_permission_camera: camera,
                                setting_permission_mic: microphone,
                            },
                            System_error: {
                                errorData: data,
                                errorName: name,
                            },
                            User_params: {
                                [provider.tokenName]: provider.token,
                            },
                        },
                    },
                    goal: GoalType.DEV,
                });
            })();
        },
        [triggerYM, conferenceId, currentUser?.role],
    );
}
